import React, { useEffect, useRef } from "react";

interface LazyImageProps {
  src: string;
  blurDataURL?: string; // Base64 encoded tiny preview
  alt: string;
  [key: string]: any;
}

const LazyImage = ({ src, blurDataURL, alt, ...props }: LazyImageProps) => {
  const imgRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const lazyImage = entry.target as HTMLImageElement;
            lazyImage.addEventListener('load', () => {
              lazyImage.style.filter = 'none';
              lazyImage.style.opacity = '1';
            });
            lazyImage.src = lazyImage.dataset.src || '';
            observer.disconnect();
          }
        });
      },
      {
        rootMargin: "0px 0px 200px 0px",
      }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => {
      if (imgRef.current) {
        observer.unobserve(imgRef.current);
      }
    };
  }, [src]); // Add src to dependency array

  return (
    <img 
      ref={imgRef} 
      data-src={src} 
      alt={alt} 
      src={blurDataURL || "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"}
      style={{
        opacity: 0,
        transition: 'opacity 0.3s ease-in-out, filter 0.3s ease-in-out',
        filter: 'blur(20px)'        
      }}
      {...props} 
    />
  );
};

export default LazyImage;
